import { errorlog } from '@/libs/error-logs';
import { toError } from '@/utils/errors';

import { GET } from './base/index';
import { ENDPOINTS } from './endpoints';

type IndicationResponse = {
  indications: Record<string, { indication: string; methods: string }>;
};

export async function getIndications({ site_id }: { site_id?: string }) {
  try {
    const response = await GET<IndicationResponse>(ENDPOINTS.ORDER_INDICATIONS, {
      query: site_id ? { site_id, provider_id: 'TEST_ID' } : undefined,
    });
    return response.indications;
  } catch (error) {
    errorlog(error as Error, 'src/api/indications', 'Error fetching Indications');
    return Promise.reject(toError(error));
  }
}
